import React from 'react'
import PropTypes from 'prop-types'

const LoadingWave = props => {
  const angry = props.angry || false
  const dots = props.dots || 8
  const position = props.position || 'left'

  const className = `LoadingWave_Dot${angry ? '-angry' : ''}`

  return (
    <div className={`LoadingWave mt-5 text-${position} h-40px`}>
      {[...Array(dots).keys()].map((x, index) => {
        const dotStyle = {
          animationDelay: `${100 * index}ms`,
        }

        return (
          <span
            key={index}
            className={`${className} d-inline-block h-10px w-10px rounded-circle align-bottom`}
            style={dotStyle}
          />
        )
      })}
    </div>
  )
}

LoadingWave.propTypes = {
  angry: PropTypes.bool,
  dots: PropTypes.number,
}

export default LoadingWave
